module.exports = {
  title: 'Waveform Scrubber with React Native Reanimated 🎵',
  author: 'Enzo Manuel Mangano',
  date: '2023-05-10',
  slug: 'audio-player',
  tags: ['reanimated'],
};
